class MetricsService {
    constructor() {
        this.enabled = false;
        this.metricsProvider = null;
    }

    enable() {
        this.enabled = true;
    }

    disable() {
        this.enabled = false;
    }

    isEnabled() {
        return this.enabled;
    }

    setDeviceMetricsProvider(provider) {
        this.metricsProvider = provider;
    }

    getDeviceMetricsProvider() {
        return this.metricsProvider;
    }
}

export default new MetricsService();
